import { Icon } from '@/features/common/Icon';
import { publicRegistry } from '@/i18n/dictionaries/publicRegistry';
import { useTranslation } from '@/i18n/useTranslation';
import type { AdvisorStatTilesProps } from '@/features/publicsite/types/registry/AdvisorStatTilesProps';

/** The registry's two stat tiles: active advisers, and the zones they cover. */
export function AdvisorStatTiles({ activeCount, zoneCount }: AdvisorStatTilesProps) {
  const { t } = useTranslation(publicRegistry);
  return (
    <div className="stat-tiles">
      <div className="card stat-tile stat-tile--active">
        <span className="stat-tile__badge">
          <Icon name="people" />
        </span>
        <span>
          {/* Counts what is on screen, as the template did: searching narrows this number too. */}
          <strong>{activeCount}</strong>
          <span>{t('advisorsActive')}</span>
        </span>
      </div>
      <div className="card stat-tile">
        <span className="stat-tile__badge">
          <Icon name="map-pin" />
        </span>
        <span>
          <strong>{zoneCount}</strong>
          <span>{t('advisorsZones')}</span>
        </span>
      </div>
    </div>
  );
}
